export default __webpack_public_path__ + "static/post3-e1e578ca2d7154ac1676de9fd2aafa78.jpg";